/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 649:
/***/ (() => {

for (const [key, value] of Object.entries(meta.page)) {
  if (`${key}` == 'pageType' && `${value}` == 'product') {
    let width = document.body.offsetWidth;

    document.addEventListener('DOMContentLoaded', function (event) {
      let btnQuote = document.querySelector(
        '.product .buy-buttons button.rfq-btn'
      );
      if (btnQuote) {
        let cloneBtn = btnQuote.cloneNode(true);
        document
          .querySelector('.product-quick-add__variant .v-stack')
          .after(cloneBtn);

        setTimeout(function () {
          document
            .querySelector('.horizontal-product__cta button')
            .after(cloneBtn);
        }, 1000);

        function btnQuoteMobile() {
          if (width < 700) {
            document
              .querySelector('.product-quick-add__variant')
              .after(cloneBtn);
            cloneBtn.style.width = '100%';
          }
        }

        btnQuoteMobile();

        window.addEventListener('resize', function () {
          width = document.body.offsetWidth;
          btnQuoteMobile();
        });
      }
    });
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

// EXTERNAL MODULE: ./src/js/product.js
var product = __webpack_require__(649);
;// CONCATENATED MODULE: ./src/js/hot-spot.js
class HotSpot {
  init() {
    this.hotSpots = document.querySelectorAll('.hot-spot__dot');
    if (this.hotSpots) {
      this.manageClick();
    }
  }

  manageClick() {
    for (let hotSpot of this.hotSpots) {
      const config = { attributes: true, childList: false, subtree: false };

      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'aria-expanded'
          ) {
            switch (mutation.target.ariaExpanded) {
              case 'true':
                hotSpot.classList.add('hot-spot__dot--active');
                break;
              case 'false':
                hotSpot.classList.remove('hot-spot__dot--active');
                break;
            }
          }
        }
      };

      const observer = new MutationObserver(callback);

      observer.observe(hotSpot, config);
    }
  }
}

;// CONCATENATED MODULE: ./src/main.js


// JS goes here


window.addEventListener('load', () => {
  const globalComponents = [new HotSpot()];
  globalComponents.forEach((component) => component.init());
});

})();

/******/ })()
;